import * as Sentry from '@sentry/react';
import React from 'react';
import { ErrorMessage } from './ErrorMessage';

export const ErrorBoundary = ({ children }: { children: React.ReactNode }) => {
  return <Sentry.ErrorBoundary fallback={ErrorMessage}>{children}</Sentry.ErrorBoundary>;
};
